
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/cancellation-policy",
      function () {
        return require("private-next-pages/terms/cancellation-policy/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/cancellation-policy"])
      });
    }
  